import { MarketingRepo } from '@core/repositories'

const orderResource = '/orders'

export default {
  /**
   * @used in Contact Dashboard UI
   */
  fetch (config) {
    return MarketingRepo.get(`${orderResource}.json`, config)
  },
  show (orderId, config) {
    return MarketingRepo.get(`${orderResource}/${orderId}.json`, config)
  },
  orderTypes (config) {
    return MarketingRepo.get(`${orderResource}/types.json`, config)
  },
}

